import RestDataService from '@yakit/core/api/RestDataService'


export default function PromiseApi(opts) {
  const api = RestDataService({ ...opts, key: 'ar/promise' })

  api.createPromise = ({ customerId, amount, dueDate, refnum, lines }) => {
    const json = {
      customer: { id: customerId },
      amount,
      dueDate,
      lines: lines.map((line) => {
        const row = {
          amount: line.amount,
          arTran: { id: line.id }
        }
        if (line.discAmount != null && line.discAmount !== '') row.discAmount = Number(line.discAmount)
        return row
      })
    }
    if (refnum) json.refnum = refnum
    return api.create(json, { includesKey: 'get' })
  }

  return api
}
